<template>
  <div id="permission">
    <div class="title">
      <div>权限组配置</div>
    </div>
    <div class="main">
      <el-tabs
        class="groups-list"
        v-model="activeName"
        @tab-click="handleClick"
        tab-position="left"
      >
        <el-tab-pane
          v-for="(group, groupIndex) in response.groups"
          :key="groupIndex"
          :label="group.displayName"
          :name="group.displayName"
        ></el-tab-pane>
      </el-tabs>
      <el-form class="el-form" v-if="response">
        <div
          v-for="(group, groupIndex) in response.groups"
          :key="groupIndex"
          class="form-li"
          v-show="group.displayName == activeName"
        >
          <div class="table-tit">
            <div class="table-val">
              <div class="table-name">{{ group.displayName }}</div>
            </div>
            <div class="table-tips">说明</div>
          </div>
          <div
            class="table-info"
            v-for="(permission, permissionsIndex) in group.permissions"
            :key="permissionsIndex"
          >
            <div class="table-val">
              <div
                class="table-name"
                :class="{ subset: permission.parentName }"
              >
                {{ permission.displayName }}
              </div>
              <div class="table-operation" v-if="permission.isDropdownBox">
                <el-dropdown
                  @command="handleCommand"
                  trigger="click"
                  placement="bottom"
                >
                  <span class="el-dropdown-link">
                    {{ permission.selectedScope | typeFile }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" class="opertion-dropdown">
                    <el-dropdown-item
                      v-for="scope in permission.scopes"
                      :key="scope.name"
                      :command="beforeHandleCommand(permission, scope.name)"
                    >
                      <span>{{ scope.displayName }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-select
                @change="changeClaims(permission,permission.selectedScope)"
                v-model="permission.selectedScope"
              >
                <el-option
                  v-for="scope in permission.scopes"
                  :key="scope.name"
                  :label="scope.displayName"
                  :value="scope.name"
                ></el-option>
              </el-select>-->
              </div>
              <div class="table-operation" v-else>
                <el-switch
                  v-model="permission.selectedScope"
                  active-value="Granted"
                  inactive-value="Prohibited"
                  :disabled="isDisabled"
                  @click.native="showDisable"
                  @change="
                    changeSelectedScope(permission.selectedScope, permission)
                  "
                ></el-switch>
              </div>
            </div>
            <div class="table-tips">{{ permission.description }}</div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getPermissions, updataPermissions } from "@/http/api/permission";
import { debounce } from "@/utils/debounce";

export default {
  props: {
    roleId: { type: String }, //权限组名称
  },
  data() {
    return {
      response: {},
      activeName: "身份标识管理",
      permissionList: this.$store.getters.permissions, //用户权限集合
      isDisabled: true,
    };
  },
  created() {
    this.$watch(
      "roleId",
      debounce((val) => {
        this.getPermissionsInfo();
      }, 200)
    );
  },
  mounted() {
    this.getPermissionsInfo();
    this.isDisabled = !this.permissionList[
      "RocketIdentity.Roles.ManagePermissions"
    ];
  },
  methods: {
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无权限组更改权限`,
          showClose: true,
        });
      }
    },
    changeSelectedScope(val, item) {
      this.changeClaims(item, val);
    },
    handleClick(val) {},
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      if (!this.isDisabled) {
        this.changeClaims(command.row, command.command);
        // if (command.command == "发布") {
        //   showStatusChange(command.row, "Published");
        // } else if (command.command == "取消发布") {
        //   this.preview(command.row);
        // } else if (command.command == "删除") {
        //   this.openDeleted(command.row);
        // } else if (command.command == "日志") {
        //   this.toHistory(command.row);
        // }
      } else {
        this.$message.warning({
          message: `您暂无权限组更改权限`,
          showClose: true,
        });
      }
    },
    getPermissionsInfo() {
      //console.log(this.roleId, 123123);

      let query = {
        providerName: "R",
        providerKey: this.roleId,
      };
      getPermissions(query).then((res) => {
        this.response = res.result;
      });
    },

    changeClaims(permission, selectedScope) {
      //console.log(permission, selectedScope, 222222222);
      var query = {
        providerName: "R",
        providerKey: this.roleId,
      };
      var data = {
        permissions: [
          {
            name: permission.name,
            scope: selectedScope,
          },
        ],
      };
      updataPermissions(query, data).then((res) => {
        if (res.code == 10200) {
          this.getPermissionsInfo();
          this.$store.dispatch("ChangePermissions");
          this.$message.success({
            message: "权限配置更新成功",
            showClose: true,
          });
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#permission {
  padding: 20px;
  text-align: left;
  .title {
    margin: 20px 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    color: #000;
  }
  .main {
    @include flex(row,flex-start);
    ::v-deep .groups-list {
      .el-tabs__header {
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0);
      }
      .el-tabs__active-bar{
        display: none;
      }
      .el-tabs__item{
        text-align: left;
      }
      .isactive{
        background: #f7f7f7;
      }
      .el-tabs__nav-scroll {
        padding: 0;
      }
    }
    .el-form {
      margin-left: 70px;
      width: 90%;
      .form-li {
        position: relative;
        margin-bottom: 35px;
        // padding-top: 20px;
        // border: 1px dashed #dddddd;
        .table-tit,
        .table-info {
          @include flex(row, center);
          background: #f1f1f1;
          .table-val {
            @include flex(row, center);
            justify-content: space-between;
            border-bottom: 1px solid #dfdfdf;
            border-left: 1px solid #dfdfdf;
            padding: 20px;
            width: 50%;
            height: 20px;
            line-height: 20px;
            .table-name {
              width: 85%;
              overflow: hidden;
            }
            .table-operation {
              cursor: pointer;
            }
          }

          .subset {
            padding-left: 12px;
          }
          .table-tips {
            padding: 20px ;
            border-left: 1px solid #dfdfdf;
            border-right: 1px solid #dfdfdf;
            border-bottom: 1px solid #dfdfdf;
            width: 50%;
            height: 20px;
            line-height: 20px;
          }
        }
        .table-tit {
          border-top: 1px solid #dfdfdf;
        }
        .table-info {
          background: #fff;
        }
      }
    }
  }
}
</style>
